export enum OrderExecutionEditorTabs {
  BASIC_DATA = 'basicData',
  POSITIONS = 'positions',
}
